import { css } from '@emotion/css';
import { BorderRadius, Color, Display, Font, FontWeight, JustifyContent, Spacing } from 'src/styles';

export const screen = css`
  background: ${Color.Gray1};
  ${Spacing.mt64}
`;

export const cardWrapper = css`
  width: 100%;
  ${Spacing.p24}
  background: ${Color.Gray1};
  box-shadow: 0px 4px 16px ${Color.Brand6}1A;
  ${BorderRadius.xs}
  .ant-card-body {
    ${Spacing.p0}
  }
`;

export const justifyRight = css`
  ${Display.flex}
  ${JustifyContent.flexEnd}
`;

export const changePhoneNumberButton = css`
  &.ant-btn {
    ${Spacing.px24}
  }
`;

export const label = css`
  ${FontWeight.semibold}
  ${Font.md}
  color: ${Color.Gray8};
`;

export const value = css`
  ${FontWeight.normal}
  ${Font.md}
  color: ${Color.Gray7};
`;

export const fieldLabel = css`
  ${FontWeight.normal}
  ${Font.xs}
  color: ${Color.Gray8};
`;

export const subtitle = css`
  ${Font.h4}
  color: ${Color.Brand6};
`;
